import { getRgConfiguration } from './server';
import { parseLimitOptions } from './helpers';

export const fetchLoginLimitsConfig = async () => {
    const res = await getRgConfiguration();
    return parseLimitOptions(res.data);
};
